import React from "react";
import { Link } from "react-router-dom";
import withContentFallback from "../../utils/withContentFallback";
import { educationPreviewContent } from "../../constants/homePageContent";
import "./EducationPreview.css";
import OptimizedImage from "../shared/OptimizedImage";
import { services8 } from "../../assets/images";

const EducationPreview = ({ content }) => {
  // No need for manual fallback, content already processed by HOC
  const { heading, text, buttonText, buttonLink, imageAlt } = content;

  return (
    <section className="piano-education-preview section animate-on-scroll">
      <div className="container">
        <div className="education-preview-content">
          <div className="education-preview-image">
            <OptimizedImage
              {...services8}
              sizes="(max-width: 992px) 100vw, 560px"
              alt={imageAlt}
              width="100%"
              height="100%"
            />
          </div>
          <div className="education-preview-text">
            <h2>{heading}</h2>
            <p>{text}</p>
            <Link to={buttonLink} className="btn btn-primary">
              {buttonText}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

// Wrap the component with withContentFallback HOC
export default withContentFallback(EducationPreview, educationPreviewContent);
